import { useContext } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import AppContext from "../../../AppContext";
import { CalendarFailure } from "../Components/CalendarManager";
import { ICalendarHookProps } from "../Components/CenterCalendarWorker";
import { useGetCenterCalendar } from "../Hooks/UseGetCenterCalendar";
import ICalendar from "../Types/ICalendar";

const AppContextUseGetCenterCalendar: TriggeredHook<
  ICalendar,
  undefined,
  CalendarFailure,
  ICalendarHookProps
> = props => {
  const { patient, contactId } = useContext(AppContext);
  return useGetCenterCalendar({ ...props, contactId: contactId, patientId: patient.id });
};

export default AppContextUseGetCenterCalendar;
